import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Standings from "@/pages/Standings";
import Schedule from "@/pages/Schedule";
import Syndicates from "@/pages/Syndicates";
import SyndicateDetail from "@/pages/SyndicateDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Verify from "@/pages/Verify";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import TeamAdmin from "@/pages/TeamAdmin";
import AuthCallback from "@/pages/AuthCallback";
import Stats from "@/pages/Stats";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-void text-rtrl-white">
      <Navbar />
      <main>{children}</main>
      <footer className="border-t border-surface-line mt-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 flex flex-wrap items-center justify-between gap-4">
          <div className="small-label">© 2026 Red Target Racing League — Independent player community. Not affiliated with Lucasfilm, Disney, Fuse Games, or Secret Mode.</div>
          <div className="small-label text-rtrl-red">Happy Racing Days.</div>
        </div>
      </footer>
    </div>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/standings" element={<Standings />} />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/syndicates" element={<Syndicates />} />
      <Route path="/syndicates/:id" element={<SyndicateDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/stats" element={<Stats />} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/team-admin" element={<ProtectedRoute roles={["admin","moderator","syndicate_owner","gm"]}><TeamAdmin /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell>
          <AppRoutes />
        </Shell>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
